import { render } from "./DailyCards.vue?vue&type=template&id=65c6d8c9&scoped=true"
import script from "./DailyCards.vue?vue&type=script&lang=js"
export * from "./DailyCards.vue?vue&type=script&lang=js"

import "./DailyCards.vue?vue&type=style&index=0&id=65c6d8c9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65c6d8c9"]])

export default __exports__